import React, { memo, useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  Add,
  CardComponent,
  CostTrendChart,
  Equal,
  MoneyBag,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  formatFillsBreakdown,
  formatSavingsTable,
  formatSavingsUtilizationTopCards,
} from '../core-utils/helper-utils/savingsUtilizationHelper';
import savingsUtilizationMessages from '../core-utils/messages/SavingsUtilizationMessages';
import { useStores } from '../stores';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Grid } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { numFormatterWithSuffix } from '../core-utils/helper-utils/helper';

import { LabelValueColumn } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

export interface SavingsUtilizationTopCards {}
type CombinedProps = reportProps & SavingsUtilizationTopCards;

const SavingsUtilizationTopCards: React.FC<CombinedProps> = memo(({ data }) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '1182px',
      padding: '40px 0px 66px 63px',
    },
    container: {
      marginBottom: '36px',

      position: 'relative',
    },
    titleContainer: {
      position: 'absolute',
      top: '-1px',
      left: '184px',
      display: 'flex',
      alignItems: 'center',
    },
    flex: {
      display: 'flex',
    },
    set: {
      display: 'flex',
      alignItems: 'center',
    },
  });

  const labelStyleProps = {
    fontSize: '14px',
    color: patientAccessTheme.palette.text.mediumemphasis,
  };
  const valueStyleProps = {
    fontSize: '16px',
    color: patientAccessTheme.palette.text.highemphasis,
    fontWeight: 600,
  };

  const { classes } = useStyles();

  const [costSavings, setCostSavings] = useState<any>({});
  const [prescriptionFills, setPrescriptionFills] = useState<any>({});
  const [planPaid, setPlanPaid] = useState<any>({});
  const [fillsBreakdown, setFillsBreakdown] = useState<any>({});

  const messages = savingsUtilizationMessages;
  const quaterlyReportStore = useStores().quaterlyReportStore;

  const TopCards = () => {
    return (
      <Grid
        className={classes.flex}
        style={{ gap: '1rem', flexDirection: 'column' }}
      >
        <Grid className={classes.flex} style={{ gap: '1rem' }}>
          {costSavings?.totalSavings ? (
            <CardComponent
              title={''}
              body={
                <Grid
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Grid className={classes.set}>
                    <MoneyBag style={{ width: '30px', height: '30px' }} />
                  </Grid>
                  <Grid className={classes.set}>
                    <LabelValueColumn
                      label={messages.TOP_CARDS.COST_SAVINGS}
                      value={`$${numFormatterWithSuffix(
                        costSavings.totalSavings,
                      )}`}
                      labelTypographyProps={labelStyleProps}
                      valueTypographyProps={valueStyleProps}
                    />
                  </Grid>
                  <Grid className={classes.set}>
                    <Equal />
                  </Grid>

                  {costSavings?.costSavings?.map((item: any, index: number) => (
                    <>
                      <Grid className={classes.set}>
                        <LabelValueColumn
                          label={item?.program}
                          value={`$${numFormatterWithSuffix(item?.cost)}`}
                          labelTypographyProps={labelStyleProps}
                          valueTypographyProps={valueStyleProps}
                        />
                      </Grid>
                      {index < costSavings?.costSavings?.length - 1 && (
                        <Grid className={classes.set}>
                          <Add
                            style={{ width: '31px', height: '31px' }}
                            fill={patientAccessTheme.palette.status.icon}
                          />
                        </Grid>
                      )}
                    </>
                  ))}
                </Grid>
              }
              mainGridStyles={{
                minWidth: '30%',
                maxWidth: '40%',
              }}
            />
          ) : (
            ''
          )}

          <CardComponent
            title={''}
            width="100%"
            body={
              <Grid
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Grid className={classes.set}>
                  <MoneyBag style={{ width: '30px', height: '30px' }} />
                </Grid>
                <Grid className={classes.set}>
                  <LabelValueColumn
                    label={messages.TOP_CARDS.PRESCRIPTION_FILLS}
                    value={prescriptionFills.totalfills}
                    labelTypographyProps={labelStyleProps}
                    valueTypographyProps={valueStyleProps}
                  />
                </Grid>
                <Grid className={classes.set}>
                  <Equal />
                </Grid>

                {prescriptionFills?.prescriptionFills?.map(
                  (item: any, index: number) => (
                    <>
                      <Grid className={classes.set}>
                        <LabelValueColumn
                          label={item?.program}
                          value={item?.fills}
                          labelTypographyProps={labelStyleProps}
                          valueTypographyProps={valueStyleProps}
                        />
                      </Grid>
                      {index <
                        prescriptionFills?.prescriptionFills?.length - 1 && (
                        <Grid className={classes.set}>
                          <Add
                            style={{ width: '31px', height: '31px' }}
                            fill={patientAccessTheme.palette.status.icon}
                          />
                        </Grid>
                      )}
                    </>
                  ),
                )}
              </Grid>
            }
            mainGridStyles={{
              minWidth: '30%',
              maxWidth: '50%',
            }}
          />
        </Grid>
        <CardComponent
          title={''}
          width="100%"
          body={
            <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid className={classes.set}>
                <MoneyBag style={{ width: '30px', height: '30px' }} />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.TOP_CARDS.PLAN_PAID}
                  value={`$${numFormatterWithSuffix(planPaid.totalPlanPaid)}`}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <Equal />
              </Grid>

              {planPaid?.planPaid?.map((item: any, index: number) => (
                <>
                  <Grid className={classes.set}>
                    <LabelValueColumn
                      label={item?.program}
                      value={`$${numFormatterWithSuffix(item?.cost)}`}
                      labelTypographyProps={labelStyleProps}
                      valueTypographyProps={valueStyleProps}
                    />
                  </Grid>
                  {index < planPaid?.planPaid?.length - 1 && (
                    <Grid className={classes.set}>
                      <Add
                        style={{ width: '31px', height: '31px' }}
                        fill={patientAccessTheme.palette.status.icon}
                      />
                    </Grid>
                  )}
                </>
              ))}
            </Grid>
          }
          mainGridStyles={{
            minWidth: '30%',
            maxWidth: '50%',
          }}
        />
      </Grid>
    );
  };

  const FillsAndSavingsBreakDown = () => {
    const CostTrendProps = () => {
      return {
        showDBIcon: false,
        chartTitle: 'Prescription Fills Breakdown',
        chartSubTitle:
          'This chart shows the distribution of Prescriptions Filled by Month',
        showClickHere: false,
        datasetProp: fillsBreakdown?.costTrendData,
        cardWidth: '100%',
        cardHeight: '',
        chartWidth: '100%',
        chartHeight: '290',
        yAxisTitle: 'Volume of fills',
        sAxisTitle: ' ',
        chartType: 'stackedcolumn2d',
        xAxisValues: fillsBreakdown?.xAxisValues,
        numberPrefix: '',
        showLegend: '1',
        spaceBetweenTitleAndChart: '24px',
      };
    };

    return (
      <CostTrendChart
        {...CostTrendProps()}
        chartContainerStyles={{
          width: '100%',
          height: '270px',
          overflow: 'hidden',
        }}
      />
    );
  };

  useEffect(() => {
    formatSavingsUtilizationTopCards(
      data?.savingsSummary,
      setCostSavings,
      setPrescriptionFills,
      () => {},
      setPlanPaid,
    );
    setFillsBreakdown(formatFillsBreakdown(data?.fillsBreakdown, 'right'));
    const updatedData = data?.savingsProgram?.filter(
      (item: any) => item?.savings_program !== 'Others',
    );
    quaterlyReportStore.setTableData(formatSavingsTable(updatedData));
  }, []);

  return (
    <>
      <TopCards />
      <FillsAndSavingsBreakDown />
    </>
  );
});

export default SavingsUtilizationTopCards;
